import React, {useEffect, useState} from "react";

import {
    Button,
    FlexRowSpaceBetween,
    FormControl, Space,
    Typography
} from "../../../../../common/components/libs";
import noImageForProduct from "../assets/noImageForProduct.png";
import {observer} from "mobx-react";
import {useStores} from "../../../../../hooks";
import {toRubbles} from "../../../../../common/libs";
import {
    MediaItems,
    MenuBookingCategory,
    MenuBookingItem as MenuItemType,
} from "../../../../../services/menu/models";
import {FileCopyOutlined as CopyIcon} from '@material-ui/icons';
import {EditOutlined as EditIcon} from '@material-ui/icons';
import {useHistory} from "react-router-dom";
import {FormControlLabel, Grid, Hidden, Switch} from "@material-ui/core";
import { useTranslation} from "react-i18next";
import style from "../style.module.css";
import {BookingFormType} from "../../../store/booking/forms";


interface Props {
    current?: MenuItemType,
    category: MenuBookingCategory,
}


const EditBookingItemForm = (props: Props) => {
    const {bookingStore, generalStore, modifiersSetsStore} = useStores();
    const locale = generalStore.locale.id
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState(0);
    const [media, setMedia] = useState<MediaItems[]>([]);

    const [modifiersSets, setModifiersSets] = useState<{ menuItemModifierSetId: number, sortOrder: number }[]>([]);
    const history = useHistory();

    const {current, category} = props;
    const {t} = useTranslation(["general", "booking"]);


    useEffect(() => {
        modifiersSetsStore.ensureLoaded();
    }, []);

    useEffect(() => {
        if (!current) return;
        setTitle(current.data.name[locale]);
        setDescription(current.data.description[locale]);
        setPrice(current.data.sellPrice.price);
        setMedia(current.data.media);
        setModifiersSets(current.data.menuItemModifierSets);
    }, [current]);


    if (!bookingStore.currentMenu) return null;
    if (bookingStore.currentMenu.menuCategories.length === 0) return null;
    if (bookingStore.selectedCategory === undefined) return null;
    if (!current) return;

    let imageBlockContent = [];
    const imgSrc = media.length > 0 ? (media[0].preview || media[0].source) : noImageForProduct;
    imageBlockContent.push(
        <div className={style.menuItemEditor} key="noPhoto">
            <img className={style.previewImg} src={imgSrc} alt="" key={imgSrc}/>
        </div>
    )


    const openCopyForm = (current?: MenuItemType) => {
        bookingStore.forms.showPopupForm(BookingFormType.copyBookingItem, current);
    }

    return (
        <>
            <Grid container>
                <Grid item>
                    {imageBlockContent}
                </Grid>
                <Hidden xsDown>
                    <div style={{minWidth: "20px"}}/>
                </Hidden>
                <Grid item xs={12} sm>
                    <Hidden mdUp>
                        <Typography>
                            <FormControl
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    bookingStore.toggleStopList(current, !current.data.isInStopList)
                                }}
                            >
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={current.data.isInStopList}
                                            //disabled={hasIIkoIntegration}
                                            value={!current.data.isInStopList}
                                        />
                                    }
                                    label={t("booking:menuEditor.inStopList")}
                                />
                            </FormControl>
                        </Typography>
                    </Hidden>
                    <Typography variant={"h4"} mb={2}>
                        {title}
                        {
                            current.data.isInStopList && <span
                                style={{
                                    display: 'inline-block',
                                    color: "#ff0000",
                                    marginLeft: 5,
                                    fontSize: 16,
                                    fontWeight: 400
                                }}
                            >
                                {t("booking:menuEditor.inStopListBracket")}
                                    </span>
                        }
                    </Typography>


                    <Typography variant={"body1"}>
                        {description}
                    </Typography>

                    <Typography variant={"h6"} mt={5}>
                        {t("booking:menuEditor.positionDetails")}
                    </Typography>
                    <Typography variant={"body1"}>
                        {t("booking:menuEditor.price")} {toRubbles(price)} {generalStore.currency.currencyShortName[locale]}
                    </Typography>

                    <Typography variant={"h6"} mt={5} mb={1}>
                        {t("booking:menuEditor.modifiers")}
                    </Typography>
                    {
                        modifiersSets.length > 0 &&
                        <div style={{display: "flex", flexDirection: "column"}}>

                            {
                                modifiersSets.map((item, index) => {
                                    const modifiersSet = modifiersSetsStore.getModifiersSetById(item.menuItemModifierSetId);
                                    return <FlexRowSpaceBetween
                                        key={`${item.menuItemModifierSetId}_${index}`}
                                    >
                                        {
                                            modifiersSet ?
                                                <Button
                                                    color={'primary'}
                                                    p={0}
                                                    onClick={() => {
                                                        history.push(`/menus/modifiers/${item.menuItemModifierSetId}/view`)
                                                    }}
                                                >
                                                    - {modifiersSet.data.name[locale]} ({modifiersSet.data.modifiers.length})
                                                </Button>
                                                :
                                                ""
                                        }

                                    </FlexRowSpaceBetween>
                                })
                            }
                        </div>
                    }
                    {
                        modifiersSets.length === 0 && <Typography variant={"body1"}>
                            {t("booking:menuEditor.noModifiers")}
                        </Typography>
                    }
                    <Space size={5}/>

                </Grid>
            </Grid>

            <Hidden smDown>
                <div style={{
                    textAlign: "right",
                    marginTop: 20,
                    position: "absolute",
                    top: -8,
                    right: 25
                }}>
                    <Button
                        color="primary"
                        onClick={() => {
                            history.push(`/menus/booking/${bookingStore.currentMenu.id}/${category.id}/${props.current.id}`);
                        }}
                    >
                        <EditIcon fontSize='small'/>
                        {t("general:editing")}
                    </Button>

                    <Button
                            color="primary"
                            onClick={(e: React.MouseEvent) => {
                                e.preventDefault();
                                e.stopPropagation();
                                openCopyForm(current);
                            }}
                        >
                            <CopyIcon fontSize='small'/>
                            {t("general:copy")}
                        </Button>

                </div>
            </Hidden>

            <Hidden smDown>
                <div style={{
                    textAlign: "right",
                    marginBottom: 20,
                    position: "absolute",
                    bottom: -8,
                    right: 25
                }}>
                    <FormControl
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            bookingStore.toggleStopList(current, !current.data.isInStopList)
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={current.data.isInStopList}
                                    //disabled={hasIIkoIntegration}
                                    value={!current.data.isInStopList}
                                />
                            }
                            label={t("booking:menuEditor.inStopList")}
                        />
                    </FormControl>
                </div>
            </Hidden>


            <Hidden mdUp>
                <Button
                    color="primary"
                    onClick={() => {
                        history.push(`/menus/booking/${bookingStore.currentMenu.id}/${category.id}/${props.current.id}`);
                    }}
                    fullWidth
                    variant={'contained'}
                >
                    <EditIcon fontSize='small'/>
                    {t("general:edit")}
                </Button>
            </Hidden>



        </>
    );
};

export default observer(EditBookingItemForm);
